
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-access",
      function () {
        return require("private-next-pages/get-access/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-access"])
      });
    }
  